import { render, staticRenderFns } from "./TemplateListNormal.vue?vue&type=template&id=1b46bb06&scoped=true&"
import script from "./TemplateListNormal.vue?vue&type=script&lang=js&"
export * from "./TemplateListNormal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListNormal.vue?vue&type=style&index=0&id=1b46bb06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46bb06",
  null
  
)

export default component.exports